"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsShallowCompare = _interopRequireDefault(require("react-addons-shallow-compare"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _ModuleCompatibilityTagTypes = _interopRequireDefault(require("marketplace-lib/constants/ModuleCompatibilityTagTypes"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var ANY_COMPATIBILITY = Object.freeze([_ModuleCompatibilityTagTypes.default.COMPATIBLE_BLOG, _ModuleCompatibilityTagTypes.default.COMPATIBLE_EMAIL, _ModuleCompatibilityTagTypes.default.COMPATIBLE_PAGE]);

var DefaultTagComponent = function DefaultTagComponent(_ref) {
  var tagTitle = _ref.tagTitle;
  return tagTitle;
};

var ModuleCompatibilityTagsList =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ModuleCompatibilityTagsList, _Component);

  function ModuleCompatibilityTagsList() {
    (0, _classCallCheck2.default)(this, ModuleCompatibilityTagsList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ModuleCompatibilityTagsList).apply(this, arguments));
  }

  (0, _createClass2.default)(ModuleCompatibilityTagsList, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare.default)(this, nextProps, nextState);
    }
  }, {
    key: "renderTag",
    value: function renderTag(tag, TagComponent) {
      return CustomRenderer.render(TagComponent, {
        key: tag,
        tag: tag,
        tagTitle: _react.default.createElement(_FormattedMessage.default, {
          message: "marketplacelib.ModuleCompatibilityTagTypes." + tag
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          ListComponent = _this$props.listComponent,
          _moduleCompatibility = _this$props.moduleCompatibility,
          TagComponent = _this$props.tagComponent,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["listComponent", "moduleCompatibility", "tagComponent"]);
      var moduleCompatibility = _moduleCompatibility;

      if (moduleCompatibility.includes(_ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY)) {
        moduleCompatibility = ANY_COMPATIBILITY;
      }

      var renderedTags = moduleCompatibility.map(function (tagKey) {
        return _this.renderTag(tagKey, TagComponent);
      });
      return _react.default.createElement(ListComponent, rest, renderedTags);
    }
  }]);
  return ModuleCompatibilityTagsList;
}(_react.Component);

ModuleCompatibilityTagsList.propTypes = {
  listComponent: CustomRenderer.propType.isRequired,
  moduleCompatibility: _propTypes.default.arrayOf(_propTypes.default.oneOf(Object.keys(_ModuleCompatibilityTagTypes.default))).isRequired,
  tagComponent: CustomRenderer.propType.isRequired
};
ModuleCompatibilityTagsList.defaultProps = {
  listComponent: _UIList.default,
  tagComponent: DefaultTagComponent
};
var _default = ModuleCompatibilityTagsList;
exports.default = _default;
module.exports = exports.default;